import { z } from 'zod';

export const TransformScriptContents = z.object({
  contents: z.string(),
});

export type TransformScriptContents = z.infer<typeof TransformScriptContents>;
